<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
  tabindex="0"
  [class.disabled]="disabled"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/location_on.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>

    <h2>Região de buscas</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn-regiao"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>

<div *ngIf="dropdown.isOpen">
  <div class="regiao">
    <select
      [(ngModel)]="regiaoSelecionada"
      (change)="onSelectChange($event)"
      name="regiao"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <option *ngIf="defaultState == 0" [value]="0" disabled>
        Selecione a região
      </option>
      <option *ngIf="exibirTodasRegioes" [value]="0">TODAS AS REGIÕES</option>
      <option *ngFor="let regiao of filtroEstado" [value]="regiao.id">
        {{ regiao.description }}
      </option>
    </select>
  </div>

  @if (locations.length > 0) {
    <div class="check-total location">
      <ul>
        <li
          *ngFor="let location of locations; let i = index"
          class="location-li"
        >
          <div class="location-wrapper">
            <div class="input-label-group">
              <input
                type="checkbox"
                class="form-check-input checkbox"
                [id]="'location_' + i"
                name="checkbox_{{ location.description }}"
                (change)="onLocationCheckboxChange(location, $event)"
                [checked]="
                  selectedLocations.includes(+location.id) ||
                  selectedDistricts.includes(+location.id)
                "
                [class.disabled]="disabled"
                [disabled]="disabled"
              />
              <label class="form-check-label" [for]="'location_' + i">
                {{ location.description }}
              </label>
            </div>

            @if (location.districts && location.districts.length > 0) {
              <a class="img-container" (click)="toggleDropdownIcon(location)">
                <img
                  class="img-icon img-location"
                  src="{{
                    BASE_IMG_URL
                  }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
                  alt="Ícone de seta"
                  width="18"
                  height="18"
                />
              </a>
            }
          </div>

          <div
            *ngIf="
              location.isDropdownOpen ||
              (this.openDistritos == true && location.checked == true)
            "
            class="districts-dropdown"
          >
            <ul>
              <li
                *ngFor="let district of location.districts; let j = index"
                class="districts-li"
              >
                <input
                  type="checkbox"
                  class="form-check-input checkbox"
                  [id]="'district_' + location.id + '_' + j"
                  name="checkbox_{{ district.description }}"
                  [checked]="isDistrictChecked(district)"
                  (change)="onDistrictCheckboxChange(district, $event)"
                  [class.disabled]="disabled"
                  [disabled]="disabled"
                />
                <label
                  class="form-check-label"
                  [for]="'district_' + location.id + '_' + j"
                >
                  {{ district.description }}
                </label>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  }
</div>
